<div class="doc-section">
    <div class="doc-card" #docCard>
        <style>
            .atf-page {
                font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                font-size: 10.5pt;
                font-weight: 400;
                line-height: 1.65;
                color: #000000;
            }

            .atf-header {
                background-color: #1a2c5b;
                padding: 0 32px;
                height: 52px;
                display: flex;
                align-items: center;
            }

            .atf-brand {
                font-size: 18pt;
                font-weight: 700;
                color: #ffffff;
                line-height: 1;
            }

            .atf-brand-accent {
                color: #f0b429;
            }

            .atf-gold-bar {
                height: 5px;
                background-color: #f0b429;
            }

            .atf-body {
                padding: 20px 80px;
            }

            .atf-title {
                text-align: center;
                font-weight: 700;
                font-size: 13pt;
                text-transform: uppercase;
                color: #000000;
                margin-bottom: 4px;
            }

            .atf-subtitle {
                text-align: center;
                font-size: 10pt;
                color: #000000;
                margin-bottom: 20px;
            }

            .atf-info-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 22px;
                border: 1px solid #d1d9ea;
            }

            .atf-info-table td {
                padding: 10px 14px;
                border: 1px solid #d1d9ea;
                font-size: 10.5pt;
                width: 50%;
            }

            .atf-info-table td.lbl {
                background-color: #eef1f8;
                font-weight: 700;
                color: #000000;
            }

            .atf-info-table td.lbl-dark {
                background-color: #1a2c5b;
                color: #ffffff;
                font-weight: 700;
                font-size: 10pt;
                text-transform: uppercase;
            }

            .atf-info-table td.val {
                background-color: #ffffff;
                color: #000000;
                font-weight: 700;
                text-transform: capitalize;
            }

            .atf-info-table td.val-dark {
                background-color: #dce3f5;
                font-weight: 700;
                color: #000000;
                font-size: 10.5pt;
            }

            .atf-p {
                margin-bottom: 10px;
                font-size: 10.5pt;
                color: #000000;
            }

            .atf-heading {
                font-weight: 700;
                font-size: 10.5pt;
                color: #000000;
                text-transform: uppercase;
                letter-spacing: 0.3px;
                margin-top: 18px;
                margin-bottom: 8px;
                padding-bottom: 4px;
                border-bottom: 1px solid #c7d4f0;
            }

            .atf-sub {
                margin-top: 6px;
                margin-bottom: 6px;
                color: #000000;
                font-size: 10.5pt;
            }

            .atf-bold {
                font-weight: 700;
                color: #000000;
            }

            .atf-bold-u {
                font-weight: 700;
                text-decoration: underline;
                color: #000000;
            }

            .atf-blank {
                border-bottom: 1px solid #374151;
                display: inline-block;
                min-width: 160px;
                margin: 0 5px;
                vertical-align: bottom;
            }

            .atf-ol {
                margin-left: 20px;
                margin-top: 8px;
                margin-bottom: 14px;
            }

            .atf-ol li {
                margin-bottom: 8px;
                font-size: 10.5pt;
                color: #000000;
                padding-left: 4px;
            }

            .atf-witness {
                text-align: center;
                margin-top: 14px;
                margin-bottom: 14px;
                padding: 10px 20px;
                background-color: #f7f9fc;
                border: 1px solid #e2e8f0;
                font-size: 10.5pt;
                color: #000000;
            }

            .atf-sig-block {
                padding: 18px;
                background-color: #fafbfd;
                border: 1px solid #e2e8f0;
                border-top: 3px solid #1a2c5b;
                box-sizing: border-box;
            }

            .atf-sig-block-heading {
                font-weight: 700;
                font-size: 10pt;
                text-transform: uppercase;
                letter-spacing: 1px;
                color: #000000;
                margin-bottom: 14px;
            }


            .atf-sig-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 10px;
            }

            .atf-sig-table td {
                vertical-align: bottom;
                padding: 0;
            }

            .atf-sig-label {
                display: block;
                font-size: 8.5pt;
                font-weight: 700;
                color: #000000;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                margin-bottom: 5px;
            }

            .atf-sig-line {
                border-bottom: 1px solid #374151;
                height: 26px;
                display: block;
                width: 100%;
            }

            .atf-footer {
                background-color: #1a2c5b;
                padding: 0 32px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 8pt;
                color: #9ab0d8;
            }

            .atf-sig-canvas {
                display: block;
                width: 100%;
                height: 90px;
                border: 1.5px dashed #a0aec0;
                border-radius: 4px;
                background: #f8faff;
                cursor: crosshair;
                touch-action: none;
                transition: border-color 0.2s, background 0.2s;
            }

            .atf-sig-canvas:hover {
                border-color: #1a2c5b;
                background: #eef2ff;
            }

            .atf-sig-canvas.has-sig {
                border: 1.5px solid #1a2c5b;
                background: #f0f4ff;
                border-radius: 4px;
            }
        </style>

        <div class="atf-page">
            <div class="atf-header">
                <span class="atf-brand">E.A.S.Y. <span class="atf-brand-accent">Liens</span></span>
            </div>
            <div class="atf-gold-bar"></div>

            <div class="atf-body">
                <div class="atf-title">Assignment of Trust Funds, Obligations &amp; Responsibilities</div>
                <div class="atf-subtitle">({{ patientName }} / {{ providerName }})</div>

                <table class="atf-info-table">
                    <tr>
                        <td class="lbl">Patient</td>
                        <td class="val">{{ patientLast }}, {{ patientFirst }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Provider</td>
                        <td class="val">{{ providerName }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Date(s) of Service</td>
                        <td class="val">{{ dateOfService }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Account Number</td>
                        <td class="val">{{ accountNumber }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Full Billed Charges</td>
                        <td class="val">{{ billedCharges }}</td>
                    </tr>
                    <tr>
                        <td class="lbl lbl-dark">Amount held in trust for this account</td>
                        <td class="val val-dark">{{ trustAmount }}</td>
                    </tr>
                </table>

                <p class="atf-p">
                    This <span class="atf-bold">ASSIGNMENT OF TRUST FUNDS, OBLIGATIONS &amp;
                        RESPONSIBILITIES</span>
                    (&ldquo;Assignment&rdquo;) is made by and between {{ patientLast }}, {{ patientFirst }}
                    (&ldquo;Patient&rdquo;) and E.A.S.Y. Liens, LLC (&ldquo;Factor&rdquo;), effective as of the
                    date of
                    last execution below (&ldquo;Effective Date&rdquo;).
                </p>

                <div class="atf-heading">Patient&rsquo;s Acceptance and Assignment</div>
                <div class="atf-sub">For good and valuable consideration, Patient hereby:</div>
                <ol class="atf-ol">
                    <li><span class="atf-bold">Agrees</span> to cooperate with Factor and waive confidentiality
                        under HIPAA so Factor can communicate with Provider regarding the account set out above.
                    </li>
                    <li><span class="atf-bold">Accepts</span> the payment issued by Factor as payment in full of
                        any amounts owed to Patient arising from any discount obtained by Factor from Provider;
                    </li>
                    <li><span class="atf-bold">Assigns</span> to Factor all contractual, statutory, and
                        equitable rights, claims, defenses, and causes of action against the medical provider
                        related to the Account;</li>
                    <li><span class="atf-bold">Assigns</span> to Factor the Trust Amount identified above, to be
                        released and transferred upon Factor&rsquo;s delivery to Injury Counsel of an executed
                        <span class="atf-bold-u">Release of Lien and Authority to Distribute</span>; and</li>
                    <li><span class="atf-bold">Directs</span> Injury Counsel to execute and deliver this
                        Assignment and an <span class="atf-bold-u">Acknowledgment of Assignment</span> to
                        Factor.</li>
                </ol>

                <div class="atf-heading">Factor&rsquo;s Obligations</div>
                <div class="atf-sub">In exchange for this Assignment, Factor shall:</div>
                <ol class="atf-ol">
                    <li><span class="atf-bold-u">Issue</span> payment of <span class="atf-bold-u">{{ offerAmount }}</span> to
                        Patient within three (3) business days of the Effective Date (actual <span
                            class="atf-bold-u">delivery</span> dates may vary);</li>
                    <li>Negotiate with Provider for resolution of the Account, pay
                        the negotiated amount to Provider and obtain executed <span class="atf-bold-u">Release
                            of Lien and Authority to Distribute</span>; and</li>
                    <li>Indemnify and hold Patient harmless from claims by Hospital arising solely from the
                        Account.</li>
                </ol>

                <div class="atf-heading">No Partnership or Agency</div>
                <p class="atf-p">Nothing herein creates any partnership, joint venture, agency, or fiduciary
                    duty or relationship.</p>

                <div class="atf-heading">Entire Agreement</div>
                <p class="atf-p">This Assignment constitutes the entire agreement regarding the subject matter
                    hereof.</p>

                <div class="atf-witness">
                    <span class="atf-bold">IN WITNESS WHEREOF</span>, Patient and Factor execute below, and
                    agree to be bound hereby, effective upon the Effective Date.
                </div>

                <!-- By Patient -->
                <div class="atf-sig-block">
                    <div class="atf-sig-block-heading">By Patient:</div>
                    <table class="atf-sig-table">
                        <tr><td>
                            <span class="atf-sig-label">Full Name &nbsp;<span style="font-weight:400;text-transform:none;">(please print)</span></span>
                            <span class="atf-sig-line">{{ patientName }}</span>
                        </td></tr>
                    </table>
                    <table class="atf-sig-table">
                        <tr><td>
                            <span class="atf-sig-label">Signature <span style="font-weight:400;text-transform:none;font-size:8pt;">(draw below)</span></span>
                            <canvas #sigCanvas class="atf-sig-canvas"
                                [class.has-sig]="!state.isDrawEmpty"
                                (mousedown)="patMouseDown.emit($event)"
                                (mousemove)="patMouseMove.emit($event)"
                                (mouseup)="patMouseUp.emit()"
                                (mouseleave)="patMouseUp.emit()"
                                (touchstart)="patTouchStart.emit($event)"
                                (touchmove)="patTouchMove.emit($event)"
                                (touchend)="patTouchEnd.emit()">
                            </canvas>
                        </td></tr>
                    </table>
                    <table class="atf-sig-table">
                        <tr><td>
                            <span class="atf-sig-label">Effective Date</span>
                            <div class="inline-date-picker" data-signer="patient">
                                <app-date-picker placeholder="Select date" [showLabel]="false"
                                    [(ngModel)]="state.selectedDate"></app-date-picker>
                            </div>
                        </td></tr>
                    </table>
                </div>

                <div class="atf-page-break"></div>

                <!-- By Factor (static — pre-filled) -->
                <div class="atf-sig-block atf-sig-block--factor">
                    <div class="atf-sig-block-heading">By Factor:</div>
                    <table class="atf-sig-table">
                        <tr><td>
                            <span class="atf-sig-label">Full Name</span>
                            <span class="atf-sig-line" style="line-height:26px;padding-left:4px;font-size:10.5pt;font-weight:500;color:#000000;">Adam Johnson, CPA</span>
                        </td></tr>
                    </table>
                    <table class="atf-sig-table">
                        <tr><td>
                            <span class="atf-sig-label">Title</span>
                            <span class="atf-sig-line" style="line-height:26px;padding-left:4px;font-size:10.5pt;font-weight:500;color:#000000;">Chief Financial Officer</span>
                        </td></tr>
                    </table>
                    <table class="atf-sig-table">
                        <tr><td>
                            <span class="atf-sig-label">Signature</span>
                            <img src="assets/img/signature.png" alt="Factor Signature"
                                style="display:block;max-width:180px;height:55px;object-fit:contain;object-position:left center;">
                        </td></tr>
                    </table>
                </div>
            </div><!-- /.atf-body -->

            <div class="atf-footer">
                <span>E.A.S.Y. Liens, LLC &mdash; Confidential</span>
                <span>Assignment of Trust Funds &mdash; Page 1 of 2</span>
            </div>
        </div><!-- /.atf-page -->
    </div><!-- /.doc-card -->

</div>
